/** @jsxImportSource @emotion/react */
// import PropTypes from "prop-types";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import { useDeleteCheckMutation } from "../../../../../hooks/mutations/useCheckMutations";
import { useTriggerLayerBusinessRulesMutation } from "../../../../../hooks/mutations/useLayerMutations";
import { Button } from "../../../../Helper/Button";

import { useRouteCheck } from "../../../../../hooks/useCurrentEntities";

const InvalidCheckModal = () => {
    const check = useRouteCheck();
    const deleteCheckMutation = useDeleteCheckMutation();
    const triggerLayerBusinessRulesMutation = useTriggerLayerBusinessRulesMutation();
    const navigate = useNavigate();
    const params = useParams();
    const [isInvalidModalOpen, toggleInvalidModal] = useState(false);

    const { layer_id } = params;
    const tenantId = params.tenant_id as string;

    const markInvalid = () => {
        if (check) {
            deleteCheckMutation.mutateAsync({ check }).then(() => {
                triggerLayerBusinessRulesMutation.mutate({ layer: { tenant_id: tenantId, id: layer_id } });
                navigate(`/layer/${layer_id}`);
            });
        }
    };

    return (
        <>
            <div className="d-inline-flex d-md-block">
                <Button
                    color="danger"
                    outline
                    onClick={() => toggleInvalidModal(true)}
                    icon={faTrash}
                >
                    Delete
                </Button>
            </div>

            <Modal
                isOpen={isInvalidModalOpen}
                size="md"
                toggle={() => toggleInvalidModal(!isInvalidModalOpen)}
            >
                <ModalHeader toggle={() => toggleInvalidModal(!isInvalidModalOpen)}>
                    {`Check ${check?.check_id}`}
                </ModalHeader>

                <ModalBody>
                    <span>Please mark the check {check?.check_id} as invalid if you think something went wrong.</span>
                </ModalBody>

                <ModalFooter>
                    <Button color="light" onClick={() => toggleInvalidModal(!isInvalidModalOpen)}>
                        Cancel
                    </Button>

                    <Button color="danger" onClick={markInvalid}>
                        Mark Invalid
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default InvalidCheckModal;

